import React from "react";
import { Box } from "@bca/ui-library";

const Grade1SVG: React.FunctionComponent = () => (
  <Box display="flex">
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#009D45"/>
      <path d="M13.482 7.026V17h-1.968V9.296l-2.366.752V8.496l4.123-1.47h.211Z" fill="#fff"/>
    </svg>
  </Box>
);

export default Grade1SVG;
